<template>
  <div>
    <PageHeader page-name="Тематические Страницы">
      <template>
        <router-link :to="{name: 'CreateTopicPage'}">
          <el-button type="success">
            Добавить страницу
          </el-button>
        </router-link>
      </template>
    </PageHeader>
    <MainPanel>
      <el-table
        :data="list"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          label="#"
          type="index"
          width="50"
        />

        <el-table-column
          align="center"
          label="Состояние"
          prop="state"
          width="150"
        />

        <el-table-column
          align="center"
          label="Обновлено"
          prop="updated_at"
          width="150"
        />

        <el-table-column
          align="center"
          label="Ссылка"
          prop="url"
          width="150"
        >
          <template slot-scope="scope">
            <el-link :href="scope.row.url" type="primary">link</el-link>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="Название"
          prop="title"
        />
        <el-table-column fixed="right" width="120">
          <template slot-scope="scope">
            <el-button
              size="small"
              type="success"
              @click="onEdit(scope.row.id)"
            >
              <i class="far fa-edit" />
            </el-button>
            <el-button
              size="small"
              type="danger"
              @click="onDelete(scope.row.id)"
            >
              <i class="far fa-trash-alt" />
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </MainPanel>
  </div>
</template>

<script>

import {mapActions, mapState} from 'vuex'
import MainPanel from '../../components/common/MainPanel.vue';
import PageHeader from '@/components/common/PageHeader';

export default {
  name: 'TopicsListPage',
  components: {PageHeader, MainPanel},
  computed: {
    ...mapState('topics', {
      list: state => state.topics,
    }),
  },
  created() {
    this.getAllTopics()
  },
  methods: {
    ...mapActions('topics', ['getAllTopics', 'deleteTopic']),

    onEdit(id) {
      this.$router.push({name: 'EditTopicPage', params: {id}})
    },
    async onDelete(id) {
      try {
        const res = await this.$confirm('Вы действительно хотите удалить эту тематическую страницу?')
        if (res) {
          await this.deleteTopic(id)
          await this.getAllTopics()
        }
      } catch {
      }
    },
  },
}
</script>
